// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a2c9fc70","5":"30638d5b"}[chunkId] + ".chunk.js";
};